/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmSkillsGetVersion } from "../../funcs/llmSkillsGetVersion.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetSkillVersionRequest$inboundSchema,
};

export const tool$llmSkillsGetVersion: ToolDefinition<typeof args> = {
  name: "llm-skills-get-version",
  description: `Retrieve skill version

Returns information about a specific skill version.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmSkillsGetVersion(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
